var jquery = require("jquery");
var cookie = require("jquery.cookie");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import ScrollOut from "scroll-out";
import { gsap } from "gsap";
// import ScrollTrigger from 'gsap/ScrollTrigger';

ScrollOut({
	once: true,
	threshold: window.innerWidth <= 1024 ? 0 : 0.2,
	cssProps: {
		viewportY: true,
	},
});


var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

// READY

$(function () {

	// console.log('Website proudly by Imagic Creative!');

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	setInterval(function() {
		if ($('.header-dropdown[data-expanded="true"]').length) {
			$('body').attr('data-menu-expanded', 'true');
		} else {
			$('body').attr('data-menu-expanded', 'false');
		}
	}, 100);


	setInterval(function() {
		if (window.location.hash) {
			// Extract the section number from the hash
			var sectionNumber = window.location.hash.substring(9); // Assuming #section-XXX format
			var section = $('[data-ni-block-id="' + sectionNumber + '"]');
			if (section.length) {
				$('html, body').animate({
					scrollTop: $('[data-ni-block-id="' + sectionNumber + '"]').offset().top
				}, 'slow');
			}

			// Remove the hash from the URL after scrolling
			history.replaceState({}, document.title, window.location.pathname);
			$('header').removeClass('nav-up').removeClass('nav-down').removeClass('nav-fixed-homepage');
		}
	}, 250);

	// setInterval(function() {
	// 	bodyBg();
	// }, 250);

	ticker();

	var scrollTop = $(window).scrollTop();

	galleryScroll(scrollTop);

	if ($('[data-section="listType1"]').length) {
		var firstAccordion = $('[data-section="listType1"]').first().find('button.accordion').first();
		if (firstAccordion.length) {
			firstAccordion.trigger('click');
		}
	}

	readMore();

	// Initialize header state on page load
	setTimeout(function() {
		hasScrolled();
	}, 100);

	// Initialize video popups - hide them initially
	$('[data-video-popup-container]').hide();



	// Subscribe popup
	const announcement = $('aside[data-type="announcement"]');

	function setAnnouncementSlideHeights() {
		var $slides = announcement.find('.swiper-slide');
		
		if (!$slides.length) return;

		// Reset heights to auto so we can measure natural heights
		$slides.css('height', 'auto');
		announcement.css('height', 'auto');

		var maxHeight = 0;
		$slides.each(function() {
			var h = $(this).outerHeight(true);
			if (h > maxHeight) maxHeight = h;
		});

		// Apply the tallest height to all slides and the container
		$slides.css('height', maxHeight + 'px');
		announcement.css('min-height', maxHeight + 'px');
	}

	$(document).ready(function() {
		// announcements
		if (!localStorage.getItem('announcementClosed')) {
			$('body').attr('data-announcement', 'true');
			announcement.stop().fadeIn(0);
			setTimeout(function() {
				setAnnouncementSlideHeights();
				
				if ($('#map').length && !$('#map[data-component]').length && $('[data-map-panel]').length) {
					$('main').css('padding-top', announcement.outerHeight() + 'px');
				}
				if ($('.headerContainer').length) {
					var newHeight = $('header').outerHeight() + announcement.outerHeight();
					$('header').height(newHeight);
				}
			}, 300);
		} else {
			$('body').attr('data-announcement', 'false');
		}

		$('.close-announce').on('click', function() {
			announcement.stop().slideUp(function () {
				$('body').attr('data-announcement', 'false');
				// This runs after fadeIn completes
				if ($('#map').length && !$('#map[data-component]').length && $('[data-map-panel]').length) {
					$('main').css('padding-top','0px');
				}
				if ($('.headerContainer').length) {
					$('header').height(navbarHeight);
				}
			});
			localStorage.setItem('announcementClosed', 'true');
		})

		// subscribe popup
		// 5 seconds load popup
		var popupTimout = setTimeout(function() {
			// console.log('triggered by timeout');
			initPopup();
			clearTimeout(popupTimout);
		}, 5000);

		//page scroll 50% init popup
		var windowScrollTrigger = $(document).height() / 2;
		$(window).scroll(function() {
			if ($(window).scrollTop() > windowScrollTrigger) {
				// console.log('triggered by pagescroll');
				initPopup();
			}
		});

		// exit intent
		$(document).on('mouseleave', function(e) {
			if (e.clientY < 0) {
				// console.log('triggered by exit intent');
				initPopup();
			}
		});

		// bind events
		function switchSubscribePanel(target) {
			var $popup = $('#subscribe-popup');
			var $current = $popup.find('.subscribe-popup-panel.is-active');
			var $next = $popup.find('.subscribe-popup-panel[data-panel="' + target + '"]');

			if (!$next.length) return;

			$current.stop().fadeOut(200, function() {
				$current.removeClass('is-active');
				$next.addClass('is-active').hide().stop().fadeIn(200);
			});
		}

		$('#subscribe-popup').on('click', '[data-subscribe-next]', function() {
			switchSubscribePanel($(this).data('subscribe-next'));
		});

		$('#subscribePopup').on('freeform-ajax-success', function(event) {
			localStorage.setItem('subscribePopup', 'true');
			switchSubscribePanel('thanks');
		})

		$('#subscribe-popup button.close').on('click', function() {
			localStorage.setItem('subscribePopup', 'true');
			$('#subscribe-popup').stop().fadeOut();
		})

		function initPopup() {
			if (!localStorage.getItem('subscribePopup') && !$('#subscribe-popup').data('subscribe-popup-init')) {
				$('#subscribe-popup').stop().fadeIn();	
				$('#subscribe-popup').data('subscribe-popup-init', true);
			}
		}
	})

	$(window).on('resize', function() {

		setAnnouncementSlideHeights();

		if ($('.accordion.is-open').length) {
			$('.accordion.is-open').each(function() {
				var content = $(this).parent().find('.accordion-content');

				var maxH = 0;
				content.find('> div').each(function() {
					var divHeight = $(this).outerHeight();
					if ($(window).width() < 1024) {
						maxH += divHeight;
					} else {
						if (divHeight > maxH) {
							maxH = divHeight;
						}
					}
				});

				maxH += 40;

				content.css('max-height', maxH);
			})
		}

		readMore();

	});

});

// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

	var scrollTop = $(window).scrollTop();

	// bodyBg();

	ticker();

});




// ACCORDION
$(document).on('click', '.accordion:not(.is-open)', function(e) {
	// $(this).parent().parent().find('.accordion.is-open').trigger('click');
	$(this).addClass('is-open').attr('aria-expanded', 'true');
	var content = $(this).parent().find('.accordion-content');

	var maxH = 0;
    content.find('> div').each(function() {
        var divHeight = $(this).outerHeight();
		if ($(window).width() < 1024) {
			maxH += divHeight;
		} else {
			if (divHeight > maxH) {
				maxH = divHeight;
			}
		}
    });

	maxH += 40;

	content.css('max-height', maxH);
});
$(document).on('click', '.accordion.is-open', function(e) {
	$(this).removeClass('is-open').attr('aria-expanded', 'false');
	var content = $(this).parent().find('.accordion-content');
	content.removeAttr('style');
});

//////////////////////////////////////////



// HEADER theme change
var $firstSection = $('main section[data-first]').first();
if ($firstSection.length) {
	var bg = $firstSection.attr('data-bg');
	if (bg)
		$('header').attr('data-theme', bg);
}



// DROPDOWN (backdrop) HELPER
function toggleDropdownOverlay(show, callback) {
    var overlay = $('.header-dropdown-overlay');
    if (show) {
        var dropdown = $('.header-dropdown[data-expanded="true"]');
        if (dropdown.length) {
            var hAnnounce = $('aside.announcement').outerHeight() || 0;
            var hMenu = $('.section-menu-main').outerHeight();
            var hDropdown = dropdown.outerHeight();
            var totalHeight = hAnnounce + hMenu + hDropdown;

            gsap.to(overlay[0], {
                height: totalHeight,
                opacity: 1,
                duration: 0.3,
                ease: 'power2.out',
                onStart: function() {
                    overlay.addClass('active');
                },
                onComplete: function() {
                    if (callback) callback();
                }
            });
        }
    } else {
        gsap.to(overlay[0], {
            height: 0,
            opacity: 0,
            duration: 0.3,
            ease: 'power2.in',
            onComplete: function() {
                overlay.removeClass('active');
                if (callback) callback();
            }
        });
    }
}

// Align sub items to parent
function alignDropdownToParent($parent) {
    var target = $parent.attr('data-target');
    var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]');
    if (!dropdown.length) return;

	var $link = $parent.find('a');
    var linkLeft = $link.offset().left;
    var containerLeft = $('.header-menu .container').offset().left;
    var offset = linkLeft - containerLeft;

    dropdown.find('.row').css({
        'justify-content': 'flex-start',
        'padding-left': offset + 'px'
    });
}



// MENU HOVER

$('header .column-menu .menu-parent').on('click', function() {
	// console.log('CLICK')
	var target = $(this).attr('data-target');
	if ($(this).hasClass('active')) {
		$('header .column-menu .menu-parent').removeClass('active');
		$(this).removeClass('active');
		var dropdowns = $('.header-dropdown[data-dropdown]')
		var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
		
		dropdowns.each(function() {
			gsap.killTweensOf(this);
		});
		dropdowns.attr('data-expanded', false).css('opacity', 0);

		dropdown.attr('data-expanded', false);

    	toggleDropdownOverlay(false);
	} else {
		$('header .column-menu .menu-parent').removeClass('active');
		$(this).addClass('active');
		var dropdowns = $('.header-dropdown[data-dropdown]')
		var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')

		dropdowns.each(function() {
			gsap.killTweensOf(this);
		});
		dropdowns.attr('data-expanded', false).css('opacity', 0);

		dropdown.attr('data-expanded', true).css('opacity', 0);

		alignDropdownToParent($(this));
    	toggleDropdownOverlay(true);

		gsap.to(dropdown[0], {
			opacity: 1,
			delay: 0.1,
			duration: 0.2,
			ease: 'power2.out'
		});
	}
});

$('header .column-menu .menu-parent').on('mouseover', function() {
    if (isTouchDevice()) {
        return false;
    }
    var target = $(this).attr('data-target');
    $('header .column-menu .menu-parent').removeClass('active');
    $(this).addClass('active');
    
    var dropdowns = $('.header-dropdown[data-dropdown]');
    var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]');

    // Instantly hide all other dropdowns (no slide animation)
    dropdowns.not(dropdown).attr('data-expanded', false).css('opacity', 0);
    
    // Kill any running GSAP tweens on this dropdown
    gsap.killTweensOf(dropdown[0]);
    
    dropdown.attr('data-expanded', true).css('opacity', 0);

    alignDropdownToParent($(this));
    toggleDropdownOverlay(true);

    gsap.to(dropdown[0], {
        opacity: 1,
        delay: 0.1,
        duration: 0.2,
        ease: 'power2.out'
    });
});

$('header .column-menu .menu-parent:not(.menu-parent-children)').on('mouseover', function() {
    if (isTouchDevice()) {
        return false;
    }
    $('header .column-menu .menu-parent').removeClass('active');
    var dropdowns = $('.header-dropdown[data-dropdown]');
    
	dropdowns.each(function() {
		gsap.killTweensOf(this);
	});
	dropdowns.attr('data-expanded', false).css('opacity', 0);
    toggleDropdownOverlay(false);
});
$('body').on('mouseover', function(event) {
	if (isTouchDevice()) {
		return false;
	}
	if (
		!$(event.target).hasClass('menu-parent') && 
		!$(event.target).hasClass('header-menu') && 
		!$(event.target).parent().hasClass('menu-parent') && 
		!$(event.target).closest('.header-dropdown').length && 
		!$(event.target).hasClass('header-dropdown') || 
		$(event.target).closest('section').length
	) {
		// console.log($(event.target))
		// console.log($(event.target).hasClass('header-dropdown'))
		$('header .column-menu .menu-parent-children').removeClass('active');
		var dropdowns = $('.header-dropdown[data-dropdown]')
		
		dropdowns.each(function() {
			gsap.killTweensOf(this);
		});
		dropdowns.attr('data-expanded', false).css('opacity', 0);

   		toggleDropdownOverlay(false);
	}
});
$('body').on('click', function(event) {
	// if (isTouchDevice()) {
		if (
			!$(event.target).hasClass('menu-parent') && 
			!$(event.target).hasClass('header-menu') && 
			!$(event.target).parent().hasClass('menu-parent') && 
			!$(event.target).closest('.header-dropdown').length && 
			!$(event.target).hasClass('header-dropdown') || 
			$(event.target).closest('section').length
		) {
			$('header .column-menu .menu-parent-children').removeClass('active');
			var dropdowns = $('.header-dropdown[data-dropdown]')
			
			dropdowns.each(function() {
				gsap.killTweensOf(this);
			});
			dropdowns.attr('data-expanded', false).css('opacity', 0);

    		toggleDropdownOverlay(false);
		}
	// }
});

// MENU TOUCH DESKTOP

$('header .column-menu .menu-parent-children a').on('click', function(e) {
	if (isTouchDevice()) {
		e.preventDefault();
		var dropdowns = $('.header-dropdown[data-dropdown]')
		if ($(this).hasClass('active')) {
			$('header .column-menu .menu-parent-children').removeClass('active');
			
			dropdowns.each(function() {
				gsap.killTweensOf(this);
			});
			dropdowns.attr('data-expanded', false).css('opacity', 0);
		} else {
			var target = $(this).parent().attr('data-target');
			$('header .column-menu .menu-parent-children').removeClass('active');
			$(this).parent().addClass('active');
			var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
			
			dropdowns.each(function() {
				gsap.killTweensOf(this);
			});
			dropdowns.attr('data-expanded', false).css('opacity', 0);
			dropdown.attr('data-expanded', true);
		}
	}
});


function hasScrolled() {
	
	if ($('body.mobile-menu-open').length) {
		return;
	}

	if ($('footer[data-scroll="in"]').length && $(window).width() < 1024) {
		$('header').removeClass('nav-up').addClass('nav-down').removeClass('nav-fixed-homepage');
		return;
	}

	// Check if homepage-header class is present
	var isHomepageHeader = $('.headerContainer').hasClass('homepage-header');
	
	if (isHomepageHeader) {
		// Get the first hero section inside main
		var heroSection = $('main section[data-section="heroType3"]').first();
		
		if (heroSection.length) {
			var scrollTop = $(window).scrollTop();
			var heroTop = heroSection.offset().top;
			var heroBottom = heroTop + heroSection.outerHeight();
			var viewportTop = scrollTop;
			
			// Check if viewport top is within the hero section
			if (viewportTop >= heroTop && viewportTop < heroBottom) {
				// Within hero section - make it fixed persistently without animation
				$('header').removeClass('nav-up').removeClass('nav-down').addClass('nav-fixed-homepage');
				lastScrollTop = scrollTop;
				return;
			} else {
				// Past hero section - use normal behavior
				$('header').removeClass('nav-fixed-homepage');
				
				var st = scrollTop;
				// Make sure they scroll more than delta
				if(Math.abs(lastScrollTop - st) <= delta)
					return;

				if (st > lastScrollTop && st > navbarHeight) {
					// Scroll Down
					if ($('header').hasClass('nav-down')) {
						$('header').removeClass('nav-down').addClass('nav-up');
						$('.header-menu').addClass('scrolled');
					} else if (!$('header').hasClass('nav-up') && !$('header').hasClass('nav-down')) {
						// If header doesn't have nav-down yet, add nav-up when scrolling down past hero
						$('header').addClass('nav-up');
					}
				} else {
					// Scroll Up
					if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
						$('header').removeClass('nav-up').addClass('nav-down');
						$('.header-menu').addClass('scrolled');

					} 
					
					if(st < 5) {
						$('header').removeClass('nav-up').removeClass('nav-down');
						$('.header-menu').removeClass('scrolled');
					}
				}

				lastScrollTop = st;
			}
		} else {
			// No hero section found, use normal behavior
			var st = $(window).scrollTop();
			if(Math.abs(lastScrollTop - st) <= delta)
				return;

			if (st > lastScrollTop && st > navbarHeight) {
				$('header').removeClass('nav-down').addClass('nav-up');
			} else {
				if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
					$('header').removeClass('nav-up').addClass('nav-down');
					$('.header-menu').addClass('scrolled');
				} 
				
				if(st < 5) {
					$('header').removeClass('nav-up').removeClass('nav-down');
					$('.header-menu').removeClass('scrolled');
				}
			}

			lastScrollTop = st;
		}
	} else {
		// Normal behavior when homepage-header is not present
		var st = $(window).scrollTop();
		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;

		if (st > lastScrollTop && st > navbarHeight) {
			$('header').removeClass('nav-down').addClass('nav-up');
			$('.header-menu').addClass('scrolled');
		} else {
			// Scroll Up
			if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
				$('header').removeClass('nav-up').addClass('nav-down');
				$('.header-menu').addClass('scrolled');
			} 
			
			if(st < 5) {
				$('header').removeClass('nav-up').removeClass('nav-down');
				$('.header-menu').removeClass('scrolled');
			}
		}

		lastScrollTop = st;
	}
}


function isTouchDevice() {
	return (('ontouchstart' in window) ||
	   (navigator.maxTouchPoints > 0) ||
	   (navigator.msMaxTouchPoints > 0));
}

////////////////////////////////////////












function bodyBg() {
	var bgChanged = false;
	$('section[data-bg][data-scroll="in"]').each(function() {

		var style = $(this).css('--viewport-y');
		var viewportYValue = parseFloat(style);
		
		
		if (!bgChanged && $(this).attr('data-bg') && (viewportYValue >= -0.8 && viewportYValue < 1)) {
			$('body').attr('data-bg', $(this).attr('data-bg'));
			// console.log('viewportYValue ' + viewportYValue)
			// console.log('data-bg ' + $(this).attr('data-bg'))
			bgChanged = true;
		}
	});
}














// NUMBER TICKER
var tickerTriggered = false;

function ticker() {
	if (!tickerTriggered) {
		var numberDiv = $('[data-section="textType3"] .number .value');
		if (!numberDiv.length) {
			return false;
		}
		var inView = isElementInViewport(numberDiv[0]); // Check if the element is in view
		if (inView) {
			numberDiv.each(function () {
				var currentValue = $(this).text().replace(/,/g, ''); // Remove commas before parsing
				var targetValue = parseFloat(currentValue);
				$(this).prop('Counter', 0).animate({
					Counter: targetValue
				}, {
					duration: 1500,
					easing: 'swing',
					step: function (now) {
						$(this).text(addCommas(Math.ceil(now))); // Add commas back after rounding
					}
				});
			});
			tickerTriggered = true; // Set the flag to true after triggering the animation
		}
	}
}

// Function to check if an element is in the viewport
function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

// Function to add commas to numbers
function addCommas(nStr) {
	nStr += '';
	var x = nStr.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

////////////////////////////////////////









// MOBILE MENU

$('[data-menu-trigger] .hamburger').on("click", function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-menu-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
	if ($(this).hasClass('open')) {
		$(this).attr('aria-expanded', true);
		$('.menu-main-mobile-container').attr('aria-hidden', false);
		setTimeout(() => {
			$('.menu-main-mobile-container .bg-mobile').addClass('!opacity-100');
		}, 300);
	} else {
		$(this).attr('aria-expanded', false);
		$('.menu-main-mobile-container').attr('aria-hidden', true);
		$('.menu-main-mobile-container .bg-mobile').removeClass('!opacity-100');
	}
});

$(document).on('click', '.menu-main-mobile li.with-menu-sub button', function(e) {
	e.stopPropagation();
	$(this).parent().toggleClass('open');
	var submenu = $(this).attr('data-submenu');
	if ($(this).parent().hasClass('open')) {
		if (submenu) {
			$('.submenu-screen .menu-sub[data-submenu="' + submenu + '"]').css('display', 'flex');
		}
		$('.menu-main-mobile-container').attr('data-submenu-open', true);
	} else {
		$('.submenu-screen .menu-sub').hide();
		$('.menu-main-mobile-container').attr('data-submenu-open', false);
	}
});
$(document).on('click', '.submenu-screen .back-link', function(e) {
	e.stopPropagation();
	$('.submenu-screen .menu-sub').hide();
	$('.menu-main-mobile-container').attr('data-submenu-open', false);
	$('.menu-main-mobile li.with-menu-sub').removeClass('open');
});

$(document).on('click', 'body.mobile-menu-open .backdrop', function(e) {
	e.stopPropagation();
	$('[data-menu-trigger] .hamburger').trigger('click');
});

////////////////////////////////////////







// MAP MENU
$('[data-menu-desktop-trigger]').on("click", function(e) {
	e.stopPropagation();
	var hamburger = $(this).find('.hamburger');
	hamburger.toggleClass('open');
	if (hamburger.hasClass('open')) {
		hamburger.attr('aria-expanded', true);
		$('body').attr('data-menu-visible', true);
		$('body').attr('data-bg', 'primary-four');
	} else {
		hamburger.attr('aria-expanded', false);
		$('body').attr('data-menu-visible', false);
		$('body').attr('data-bg', 'white');
	}
});

////////////////////////////////////////








// READ MORE

function readMore() {
	var readMore = $('[data-read-more]');
	var type = readMore.attr('data-type') ?? 'default';
	if (type != 'desktop' && $(window).width() >= 1280) {
		$('[data-read]').show();
		$('[data-read-more]').hide();
		$('[data-read-less]').hide();
		return false;
	}
	if (readMore.length) {
		readMore.each(function() {
			var id = $(this).attr('data-read-more');
			$('[data-read-more="' + id + '"]').show();
			$('[data-read="' + id + '"]').hide();
		})
	}
}

$(document).on('click', '[data-read-more]', function(e) {
	var id = $(this).attr('data-read-more');
	$(this).hide();
	$('[data-read-less="' + id + '"]').show();
	$('[data-read="' + id + '"]').show();
});

$(document).on('click', '[data-read-less]', function(e) {
	var id = $(this).attr('data-read-less');
	$(this).hide();
	$('[data-read-more="' + id + '"]').show();
	$('[data-read="' + id + '"]').hide();
});

////////////////////////////////////////








// GALLERY SCROLL

function throttle(callback, limit) {
	let waiting = false;
	return function () {
		if (!waiting) {
			callback.apply(this, arguments);
			waiting = true;
			setTimeout(function () {
					waiting = false;
			}, limit);
		}
	};
}

var scrollHandler = throttle(function () {
	var scrollTop = $(window).scrollTop();
	requestAnimationFrame(function () {
		if ($(window).width() >= 1280) {
			galleryScroll(scrollTop);
		}
	});
}, 150);

$(window).on('scroll', scrollHandler);

var parallaxTicking = false;
$(window).on('scroll', function () {
	if (!parallaxTicking) {
		requestAnimationFrame(function () {
			parallaxScroll($(window).scrollTop());
			parallaxTicking = false;
		});
		parallaxTicking = true;
	}
});

function galleryScroll(scrollTop) {
	if ($(window).width() < 1280) {
		return false;
	}
	var section = $('[data-section="imageType3"][data-scroll="in"]');
	if (!section.length) {
		return false;
	}
	section.each(function() {
		var row = $(this).find('.row-gallery')
		var rowOffsetTop = row.offset().top;
		var rowWidth = 0;
		var images = row.find('.image-container');
		var viewportWidth = $(window).width();

		images.each(function() {
			rowWidth += $(this).width();
		});
		var translateX = scrollTop - rowOffsetTop + $(window).height();
		if (translateX < 0) {
		  translateX = 0;
		} else if (translateX > rowWidth - viewportWidth) {
		  translateX = rowWidth - viewportWidth;
		}
		row.css('transform', 'translateX(-' + translateX + 'px)');
	})

}

function parallaxScroll(scrollTop) {
	if ($(window).width() < 1024) {
		return;
	}
	var windowHeight = $(window).height();
	$('section[data-section="imageType1"]').each(function () {
		var section = $(this);
		var container = section.find('.image-container');
		if (!container.length) return;

		var sectionTop = section.offset().top;
		var sectionHeight = section.outerHeight();
		var sectionBottom = sectionTop + sectionHeight;

		if (scrollTop + windowHeight < sectionTop || scrollTop > sectionBottom) return;

		var progress = (scrollTop + windowHeight - sectionTop) / (windowHeight + sectionHeight);
		var maxShift = sectionHeight * 0.35;
		var translateY = (progress - 0.5) * maxShift;

		container.css('transform', 'translateY(' + translateY + 'px)');
	});

}

////////////////////////////////////////








// SECTION GALLERY POPUP

$(document).on('click', '[data-reveal-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'true');
	}
	var newHash = $(this).attr('data-reveal-gallery');
	if (newHash) {
		setTimeout(() => {
			window.location.hash = newHash;
		}, 150);
	}
});

$(document).on('click', '[data-hide-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'false');
	}
});

// SLIDER VIDEO POPUP
$(document).on('click', '[data-section="sliderType1"] .video-popup-trigger', function(e) {
	e.preventDefault();
	var videoSrc = $(this).attr('data-video-src');
	if (!videoSrc) {
		return;
	}
	
	// Add autoplay parameter if it's a YouTube or Vimeo URL
	var iframeSrc = videoSrc;
	if (videoSrc.includes('youtube.com') || videoSrc.includes('youtu.be')) {
		iframeSrc += (videoSrc.includes('?') ? '&' : '?') + 'autoplay=1';
	} else if (videoSrc.includes('vimeo.com')) {
		iframeSrc += (videoSrc.includes('?') ? '&' : '?') + 'autoplay=1';
	}
	
	var $popup = $(this).closest('[data-section="sliderType1"]').find('[data-video-popup-container]');
	var $iframe = $popup.find('[data-video-popup-iframe]');
	
	// Set iframe src and show popup with fade in
	$iframe.attr('src', iframeSrc);
	$popup.addClass('is-open');
	$('body').addClass('video-popup-open');
	$popup.stop().fadeIn(300);
});

function closeVideoPopup($popup) {
	if (!$popup || !$popup.length) {
		return;
	}
	
	var $iframe = $popup.find('[data-video-popup-iframe]');
	
	// Fade out popup, then clear iframe and remove classes
	$popup.stop().fadeOut(300, function() {
		$iframe.attr('src', '');
		$popup.removeClass('is-open');
		$('body').removeClass('video-popup-open');
	});
}

$(document).on('click', '[data-video-popup-close]', function(e) {
	e.preventDefault();
	var $popup = $(this).closest('[data-video-popup-container]');
	closeVideoPopup($popup);
});

// Close popup on ESC key
$(document).on('keydown', function(e) {
	if (e.key === 'Escape' || e.keyCode === 27) {
		var $popup = $('[data-video-popup-container].is-open');
		closeVideoPopup($popup);
	}
});

////////////////////////////////////////








// GALLERY FILTERS

const galleryImages = $('[data-section="imageType4"]').first();
const galleryVideos = $('[data-section="videoType1"]').first();

$(document).on('click', '.nav-radio[data-gallery-type]', function(e) {
	var type = $(this).attr('data-gallery-type');
	$('.nav-radio[data-gallery-type]').removeClass('active');
	$(this).addClass('active');
	if (type == "image") {
		galleryImages.show();
		galleryVideos.hide();
	} else {
		galleryImages.hide();
		galleryVideos.show();
	}
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('type', type);
	window.history.replaceState({}, document.title, url.toString());
});

$(document).on('click', '[data-section="galleryNav"] [data-filter-trigger]', function(e) {
    var filter = $(this).attr('data-filter-trigger');
    $('[data-section="galleryNav"] [data-filter-trigger]').removeClass('btn-small-active');
    $(this).addClass('btn-small-active');
	if ($(window).width() < 768) {
		$(this)[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
	}
	if (filter == 'all') {
		$('[data-filters]').show();
	} else {
		$('[data-filters]').hide();
		$('[data-filters]').each(function() {
			var filters = $(this).attr('data-filters').split(',');
			if (filters.includes(filter)) {
				$(this).show();
			}
		});
	}
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('filter', filter);
	window.history.replaceState({}, document.title, url.toString());
});

$(function () {
	var type = getUrlParameter('type');
	var filter = getUrlParameter('filter');
	if ((type || filter) && (galleryImages.length || galleryVideos.length)) {
		if (type.length && $('.nav-radio[data-gallery-type="' + type + '"]').length) {
			$('.nav-radio[data-gallery-type="' + type + '"]').trigger('click');
		}
		if (filter.length && $('[data-section="galleryNav"] [data-filter-trigger="' + filter + '"]').length) {
			$('[data-section="galleryNav"] [data-filter-trigger="' + filter + '"]').trigger('click');
		}
	}
});

////////////////////////////////////////





// HELPERS

window.getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};  

///////////////////////////////////////





// COVER PANEL ANIMATION
$(function() {
	var $coverPanel = $('.cover-panel');
	if (!$coverPanel.length) return;

	if (localStorage.getItem('coverPanelShown')) {
		$coverPanel.remove();
		return;
	}

	localStorage.setItem('coverPanelShown', 'true');

	var $heading = $coverPanel.find('.block-heading');

	$('body').css('overflow', 'hidden');

	gsap.set($heading, { opacity: 0, y: 30 });

	var tl = gsap.timeline({
		onComplete: function() {
			$coverPanel.remove();
			$(document).trigger('coverPanelDone');
		}
	});

	tl.to($heading, {
		opacity: 1,
		y: 0,
		duration: 1,
		delay: 0.25,
		ease: 'power3.out'
	})
	.to({}, { duration: 2 })
	.to($coverPanel, {
		opacity: 0,
		duration: 0.6,
		ease: 'power2.inOut',
		onStart: function() {
			$('body').css('overflow', '');
		}
	});
});

// HEADING WORD REVEAL ANIMATION

function splitTextToWords(element) {
	var words = [];

	function processNode(node) {
		if (node.nodeType === 3) {
			var text = node.textContent;
			if (!text.length) return;
			var fragment = document.createDocumentFragment();
			var parts = text.split(/(\s+)/);

			for (var w = 0; w < parts.length; w++) {
				var part = parts[w];
				if (!part.length) continue;

				if (/^\s+$/.test(part)) {
					fragment.appendChild(document.createTextNode(part));
				} else {
					var wordSpan = document.createElement('span');
					wordSpan.className = 'word';
					wordSpan.textContent = part;
					fragment.appendChild(wordSpan);
					words.push(wordSpan);
				}
			}
			node.parentNode.replaceChild(fragment, node);
		} else if (node.nodeType === 1 && node.tagName !== 'BR') {
			var childNodes = Array.from(node.childNodes);
			childNodes.forEach(processNode);
		}
	}

	Array.from(element.childNodes).forEach(processNode);
	return words;
}

function animateWordsIn(words, delay) {
	if (!words.length) return;
	gsap.fromTo(words,
		{ opacity: 0, y: '100%' },
		{
			opacity: 1,
			y: 0,
			duration: 1.6,
			stagger: 0.15,
			delay: delay || 0,
			ease: 'back.out(1.4)'
		}
	);
}

$(function() {
	// heroType3 — wait for cover panel, or animate on view
	var $hero3 = $('section[data-section="heroType3"]').first();
	if ($hero3.length) {
		var $h1 = $hero3.find('.block-heading h1');
		if ($h1.length) {
			var hero3Words = splitTextToWords($h1[0]);
			gsap.set(hero3Words, { opacity: 0, y: '100%' });

			if ($('.cover-panel').length) {
				$(document).on('coverPanelDone', function() {
					animateWordsIn(hero3Words, 0);
				});
			} else {
				var obs3 = new IntersectionObserver(function(entries) {
					if (entries[0].isIntersecting) {
						animateWordsIn(hero3Words, 0);
						obs3.disconnect();
					}
				}, { threshold: 0.1 });
				obs3.observe($hero3[0]);
			}
		}
	}

	// heroType3 — floating CTA positioning (desktop only)
	if ($hero3 && $hero3.length) {
		var $cta = $hero3.find('.block-floating-cta');
		var $blockHeading = $hero3.find('.block-heading');
		if ($cta.length && $blockHeading.length) {
			function positionHero3Cta() {
				if (!window.matchMedia('(min-width: 1024px)').matches) return;
				var headingHeight = $blockHeading.outerHeight();
				$cta.css('top', (headingHeight - 20) + 'px');
			}

			if (window.matchMedia('(min-width: 1024px)').matches) {
				gsap.set($cta[0], { opacity: 0 });
				positionHero3Cta();
				gsap.to($cta[0], {
					opacity: 1,
					duration: 0.8,
					delay: 0.2,
					ease: 'power2.out'
				});
			}

			$(window).on('resize', positionHero3Cta);
		}
	}

	// heroType1 — animate when heading scrolls into view
	$('section[data-section="heroType1"]').each(function() {
		var section = this;
		var $h1 = $(section).find('.column-text h1');
		if (!$h1.length) return;

		var $h4 = $(section).find('.column-text h4');
		if ($h4.length) {
			gsap.set($h4[0], { opacity: 0, y: 20 });
		}

		var hero1Words = splitTextToWords($h1[0]);
		gsap.set(hero1Words, { opacity: 0, y: '100%' });

		var wordsDuration = hero1Words.length * 0.12 + 1;

		var obs1 = new IntersectionObserver(function(entries) {
			if (entries[0].isIntersecting) {
				animateWordsIn(hero1Words, 0);

				if ($h4.length) {
					gsap.to($h4[0], {
						opacity: 1,
						y: 0,
						duration: 1,
						delay: wordsDuration * 0.6,
						ease: 'power2.out'
					});
				}

				obs1.disconnect();
			}
		}, { threshold: 0.1 });
		obs1.observe(section);
	});
});

///////////////////////////////////////


// HOME ANIMATION

// const splash = $('aside.splash');
// $(function () {
// 	if (splash.length) {
// 		if (window.craftLive) {
// 			if ($.cookie('splash')) {
// 				splash.children().remove();
// 				splash.fadeOut();
// 				return false;
// 			}
// 			$.cookie('splash', true);
// 		}
// 		setTimeout(() => {
// 			splash.find('svg').show();
// 			splash.find('svg').addClass('spin');
// 			splash.find('svg .logo-text').addClass('fadeIn');
// 			splash.find('.bg').addClass('fadeIn');
// 		}, 600);
// 		if (window.craftLive) {
// 			setTimeout(() => {
// 				splash.fadeOut();
// 			}, 4000);
// 		}
// 	}
// });

///////////////////////////////////////




// PRINT TRIGGER

$(document).on('click', '[data-print-trigger]', function() {
	$(this).addClass('downloading')
	if (!$(this).hasClass('link')) {
		$(this).find('span').text('Downloading')
	}
	var id = $(this).attr('data-print-trigger');
	var title = $(this).attr('data-stage-title');
	console.log('id: ', id)
	// tweaking zoom for specific stages
	if (id == 'stages-24429') {
		var zoom = 4.2;
	} else {
		var zoom = 4.55;
	}
    const iframe = $('<iframe>', {
        src: `/map-download?target=${id}&title=${title}&zoom=${zoom}`,
        class: 'h-screen w-screen -z-1 absolute opacity-0 pointer-events-none bottom-[-10000px] left-[-10000px]'
    });
    $('body').append(iframe);
});

//////////////////////////////////////




// PRINT TRIGGER

$(document).on('click', '[data-price-trigger]', function() {
	$(this).addClass('downloading')
	if (!$(this).hasClass('link')) {
		$(this).find('span').text('Downloading')
	}
	var id = $(this).attr('data-price-trigger');
	var title = $(this).attr('data-stage-title');
    const iframe = $('<iframe>', {
        src: `/price-download?target=${id}&title=${title}`,
        class: 'h-screen w-screen -z-1 absolute opacity-0 pointer-events-none bottom-[-10000px] left-[-10000px]'
    });
	console.log(id)
    $('body').append(iframe);
});



$(document).ready(function() {
	const _href = window.location.href;
	if (_href.indexOf('map-download-page') || _href.indexOf('price-download-page')) {
		$('[data-price-trigger].hidden-download-button, [data-print-trigger].hidden-download-button').trigger('click');
	}
})

//////////////////////////////////////

//data layer additionals
window.formDataStore = {};

function getFormData(formElement) {
    const excludeFields = ['CRAFT_CSRF_TOKEN', 'formHash', 'freeform-action', 'freeform_payload', 'action', 'pageUrl', 'subscribe', 'recipients'];
    return $(formElement).serializeArray().reduce((obj, item) => {
        if (!excludeFields.includes(item.name)) {
            obj[item.name] = item.value;
        }
        return obj;
    }, {});
}

// Enhanced submit handler with better logging
$('.freeform-form').each(function() {
    var $form = $(this);
    var formId = $form.attr('id');
    
    $form.on('submit', function() {
        const formData = getFormData($form);
        window.formDataStore[formId] = formData;
    });
});

// Enhanced GTM handler with better debugging
document.addEventListener('freeform-gtm-data-layer-push', function(event) {
    const form = event.form;
    const formId = form.id;
    
    if (window.formDataStore[formId]) {
        event.payload.formData = window.formDataStore[formId];
    } else {
        console.error(`[GTM EVENT] No data found for ${formId}!`);
    }
});



// CLEAN UP SH detail page image
if (window.location.href.indexOf('show-homes') !== -1) 
	modifyLogoImageSrcsets();

function modifyLogoImageSrcsets() {

    // Find banner image from show homes listing
    $('section[data-section="sectionGalleryType1"] .gallery-block > .image-container img, section[data-section="sectionCardsType1"] .card-image > .image-container img').each(function() {
        const $img = $(this);
        const altText = $img.attr('alt') || '';
        
        // Check if "Logo" is mentioned in the alt attribute (case-insensitive)
        if (altText.toLowerCase().includes('logo')) {
            $img.closest('.image-container').addClass('logo-resized');
            // Process srcset attribute on the img element
            const currentSrcset = $img.attr('srcset');
            if (currentSrcset) {
                const cleanedSrcset = cleanImgixSrcset(currentSrcset);
                $img.attr('srcset', cleanedSrcset);
            }
            
            // Also process data-srcset if it exists
            const currentDataSrcset = $img.attr('data-srcset');
            if (currentDataSrcset) {
                const cleanedDataSrcset = cleanImgixSrcset(currentDataSrcset);
                $img.attr('data-srcset', cleanedDataSrcset);
            }
            
            // Process srcset on parent source elements within the same picture
            $img.closest('picture').find('source').each(function() {
                const $source = $(this);
                const sourceSrcset = $source.attr('srcset');
                if (sourceSrcset) {
                    const cleanedSourceSrcset = cleanImgixSrcset(sourceSrcset);
                    $source.attr('srcset', cleanedSourceSrcset);
                }
                
                const sourceDataSrcset = $source.attr('data-srcset');
                if (sourceDataSrcset) {
                    const cleanedSourceDataSrcset = cleanImgixSrcset(sourceDataSrcset);
                    $source.attr('data-srcset', cleanedSourceDataSrcset);
                }
            });
        }
    });
}

function cleanImgixSrcset(srcset) {
    // Split the srcset by commas to get individual sources
    return srcset.split(',').map(function(source) {
        source = source.trim();
        
        // Split by space to separate URL and width descriptor
        const parts = source.split(' ');
        if (parts.length >= 2) {
            const url = parts[0];
            const descriptor = parts[parts.length - 1]; // Get the width descriptor (e.g., "400w")
            
            // Remove everything after the first '?' to strip all parameters
            const baseUrl = url.split('?')[0];
            
            return baseUrl + ' ' + descriptor;
        }
        
        return source; // Return as-is if format is unexpected
    }).join(', ');
}


// DOCS REVEAL

$(document).on('click', '[data-docs-revealed]', function(e) {
	var forceDesktopOpen = $(this).is('[data-docs-desktop-force-open="true"]') && window.matchMedia('(min-width: 1024px)').matches;
	if (forceDesktopOpen) {
		e.preventDefault();
		e.stopPropagation();
		$(this).attr('data-docs-revealed', 'true');
		$(this).find('.links-block').show();
		return;
	}

	var revealed = $(this).attr('data-docs-revealed');
	if (revealed == 'false') {
		$(this).attr('data-docs-revealed', 'true');
		$(this).find('.links-block').slideDown();
	} else {
		$(this).attr('data-docs-revealed', 'false');
		$(this).find('.links-block').slideUp();
	}
});

// Prevent clicks on links within the docs block from collapsing it
$(document).on('click', '[data-docs-revealed] .link', function(e) {
	e.stopPropagation();
});

// CONTACT CHECKBOX
$('.checkbox-indicator').each(function() {
	console.log('PASS');
	var $indicator = $(this);
	var $checkbox = $indicator.closest('label').find('input[type="checkbox"]');

	$checkbox.on('change', function() {
	$indicator.toggleClass('active', $checkbox.is(':checked'));
	})
})

function fadeOutVideoPlaceholder($placeholder) {
	if (!$placeholder.length || $placeholder.data('fading')) return;
	$placeholder.data('fading', true);
	gsap.to($placeholder[0], {
		opacity: 0,
		duration: 1.2,
		ease: 'power2.inOut',
		onComplete: function() {
			$placeholder.css('pointer-events', 'none');
		}
	});
}

var heroVideoPlayers = [];

function logHeroVideo(player, message, meta) {
	var prefix = '[heroVideo][' + player.id + '] ' + message;
	if (typeof meta !== 'undefined') {
		console.log(prefix, meta);
		return;
	}
	// console.log(prefix);
}

function postHeroVideoMessage(player, payload, reason) {
	if (!player.iframe || !player.iframe.contentWindow) {
		logHeroVideo(player, 'postMessage skipped: missing contentWindow', { reason: reason, payload: payload });
		return false;
	}

	try {
		player.iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
		logHeroVideo(player, 'postMessage sent', { reason: reason, payload: payload });
		return true;
	} catch (error) {
		logHeroVideo(player, 'postMessage failed', { reason: reason, error: error && error.message ? error.message : error });
		return false;
	}
}

function armHeroVideoFallback(player, ms, reason) {
	if (player.fallbackTimer) clearTimeout(player.fallbackTimer);

	logHeroVideo(player, 'fallback armed', { ms: ms, reason: reason });
	player.fallbackTimer = setTimeout(function() {
		logHeroVideo(player, 'fallback fired', {
			reason: reason,
			iframeLoaded: player.iframeLoaded,
			readySeen: player.readySeen,
			playSeen: player.playSeen,
			playProgressSeen: player.playProgressSeen
		});

		fadeOutVideoPlaceholder(player.$placeholder);
		logHeroVideo(player, 'placeholder fade triggered by fallback');
	}, ms);
}

function clearHeroVideoFallback(player, reason) {
	if (!player.fallbackTimer) return;
	clearTimeout(player.fallbackTimer);
	player.fallbackTimer = null;
	logHeroVideo(player, 'fallback cleared', { reason: reason });
}

function clearHeroVideoResumeWatchdog(player, reason) {
	if (!player.resumeWatchdogTimer) return;
	clearInterval(player.resumeWatchdogTimer);
	player.resumeWatchdogTimer = null;
	player.resumeWatchdogAttempts = 0;
	logHeroVideo(player, 'resume watchdog cleared', { reason: reason });
}

function startHeroVideoResumeWatchdog(player, reason) {
	if (!player.isHeroType3) return;
	clearHeroVideoResumeWatchdog(player, 'restart-' + reason);

	player.resumeWatchdogAttempts = 0;
	logHeroVideo(player, 'resume watchdog started', {
		reason: reason,
		intervalMs: 1000,
		maxAttempts: 8
	});

	player.resumeWatchdogTimer = setInterval(function() {
		if (document.visibilityState && document.visibilityState !== 'visible') {
			clearHeroVideoResumeWatchdog(player, 'page-hidden');
			return;
		}

		player.resumeWatchdogAttempts += 1;
		postHeroVideoMessage(player, { method: 'play' }, 'resume-watchdog-' + reason + '-' + player.resumeWatchdogAttempts);

		if (player.resumeWatchdogAttempts >= 8) {
			logHeroVideo(player, 'resume watchdog max attempts reached', { reason: reason });
			clearHeroVideoResumeWatchdog(player, 'max-attempts');
		}
	}, 1000);
}

function registerHeroVideoListeners(player) {
	['ready', 'play', 'playProgress'].forEach(function(eventName) {
		postHeroVideoMessage(player, {
			method: 'addEventListener',
			value: eventName
		}, 'register-listener-' + eventName);
	});
}

$('.video-container').each(function(index) {
	var $container = $(this);
	var $iframe = $container.find('.video-iframe');
	if (!$iframe.length) return;

	var $placeholder = $container.find('.image-container');
	var $section = $container.closest('section[data-section]');
	var sectionType = $section.attr('data-section') || 'unknown';
	var blockId = $section.attr('data-ni-block-id') || 'na';
	var playerId = sectionType + '#' + blockId + ':' + index;

	var player = {
		id: playerId,
		index: index,
		$container: $container,
		$iframe: $iframe,
		$placeholder: $placeholder,
		iframe: $iframe[0],
		sectionType: sectionType,
		isHeroType3: sectionType === 'heroType3',
		iframeLoaded: false,
		readySeen: false,
		playSeen: false,
		playProgressSeen: false,
		fallbackTimer: null,
		resumeWatchdogTimer: null,
		resumeWatchdogAttempts: 0
	};

	heroVideoPlayers.push(player);
	logHeroVideo(player, 'initialized', {
		sectionType: sectionType,
		hasPlaceholder: !!$placeholder.length,
		mode: player.isHeroType3 ? 'heroType3-layered-placeholder' : 'fade-placeholder'
	});

	$iframe.on('load', function() {
		player.iframeLoaded = true;
		logHeroVideo(player, 'iframe load detected');
		registerHeroVideoListeners(player);
		postHeroVideoMessage(player, { method: 'play' }, 'iframe-load-play-nudge');

		if (player.isHeroType3) {
			armHeroVideoFallback(player, 2500, 'heroType3-diagnostic');
		} else {
			armHeroVideoFallback(player, 5000, 'legacy-placeholder-fade');
		}
	});
});

window.addEventListener('message', function(event) {
	if (!heroVideoPlayers.length) return;

	var player = heroVideoPlayers.find(function(entry) {
		return entry.iframe && entry.iframe.contentWindow === event.source;
	});

	if (!player) return;

	var data = null;
	try {
		data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
	} catch (error) {
		logHeroVideo(player, 'message parse failed', { raw: event.data });
		return;
	}

	if (!data || typeof data !== 'object') return;
	if (!data.event) return;

	logHeroVideo(player, 'player event received', data.event);

	if (data.event === 'ready') {
		player.readySeen = true;
		postHeroVideoMessage(player, { method: 'play' }, 'ready-play-nudge');
		return;
	}

	if (data.event === 'play') {
		player.playSeen = true;
		clearHeroVideoFallback(player, 'play-event');
		clearHeroVideoResumeWatchdog(player, 'play-event');
		fadeOutVideoPlaceholder(player.$placeholder);
		logHeroVideo(player, 'placeholder fade triggered by play');
		return;
	}

	if (data.event === 'playProgress') {
		player.playProgressSeen = true;
		clearHeroVideoFallback(player, 'playProgress-event');
		clearHeroVideoResumeWatchdog(player, 'playProgress-event');
		fadeOutVideoPlaceholder(player.$placeholder);
		logHeroVideo(player, 'placeholder fade triggered by playProgress');
	}
});

function resumeHeroVideosOnVisibility(reason) {
	if (!heroVideoPlayers.length) return;
	heroVideoPlayers.forEach(function(player) {
		if (!player.isHeroType3) return;
		logHeroVideo(player, 'visibility resume requested', { reason: reason });
		postHeroVideoMessage(player, { method: 'play' }, 'visibility-resume-' + reason);
		armHeroVideoFallback(player, 2500, 'visibility-resume-' + reason);
		startHeroVideoResumeWatchdog(player, reason);
	});
}

document.addEventListener('visibilitychange', function() {
	if (document.visibilityState !== 'visible') {
		heroVideoPlayers.forEach(function(player) {
			clearHeroVideoResumeWatchdog(player, 'visibilitychange-hidden');
		});
		return;
	}
	resumeHeroVideosOnVisibility('visibilitychange-visible');
});

window.addEventListener('pageshow', function() {
	resumeHeroVideosOnVisibility('pageshow');
});

window.addEventListener('focus', function() {
	resumeHeroVideosOnVisibility('window-focus');
});

$(function() {
    // Only run on desktop
    if (!window.matchMedia || !window.matchMedia('(min-width: 1280px)').matches) return;

    var $bigLogo = $('.big-logo');
    
    if (!$bigLogo.length) return;

    var heroSection = $('section[data-section="heroType3"]')[0];
    if (!heroSection) return;

    var $imagesBlock = $(heroSection).find('.block-images');
    var lastScrollY = window.scrollY;
    var isExpanding = false;
    var frozenProgress = null;

    function updateLogoOnScroll() {
        var scrollY = window.scrollY;
        var heroTop = heroSection.offsetTop;
        var heroHeight = heroSection.offsetHeight;
        var heroBottom = heroTop + heroHeight;
        
        var scrollingDown = scrollY > lastScrollY;
        var scrollingUp = scrollY < lastScrollY;
        
        var progress;
        
        var triggerPoint = heroTop + (heroHeight * 0.25);
        
        if (scrollY < heroTop) {
            progress = 0;
            isExpanding = false;
            frozenProgress = null;
        } else if (scrollY >= triggerPoint) {
            progress = 1;
            isExpanding = false;
            frozenProgress = null;
        } else {
            var distanceToTrigger = triggerPoint - heroTop;
            var scrollBasedProgress = Math.min(Math.max((scrollY - heroTop) / distanceToTrigger, 0), 1);
            
            var isAboveTrigger = scrollY <= triggerPoint;
            
            if (scrollingDown) {
                progress = scrollBasedProgress;
                isExpanding = false;
                frozenProgress = null;
            } else if (scrollingUp) {
                if (isAboveTrigger) {
                    var progressAtTrigger = 1.0;
                    var distanceFromTriggerToTop = triggerPoint - heroTop;
                    var expansionProgress = Math.max(0, Math.min(1, (triggerPoint - scrollY) / distanceFromTriggerToTop));
                    progress = progressAtTrigger - (progressAtTrigger * expansionProgress);
                } else {
                    if (frozenProgress === null) {
                        frozenProgress = 1.0;
                    }
                    progress = 1.0;
                }
            } else {
                if (scrollY >= triggerPoint) {
                    progress = 1.0;
                } else if (frozenProgress !== null) {
                    progress = frozenProgress;
                } else {
                    progress = scrollBasedProgress;
                }
            }
        }
        
        lastScrollY = scrollY;
        
        var startWidth = 100;
        var endWidth = 20;
        var currentWidth = startWidth - ((startWidth - endWidth) * progress);
        
        var startTop = 100;
        var endTop = 50;
        var currentTop = startTop - ((startTop - endTop) * progress);
        
        var translateYPercent = -50 * progress;
        
        $bigLogo.css({
            'transition': 'none',
            'width': currentWidth + '%',
            'top': currentTop + '%',
            'transform': 'translateY(' + translateYPercent + '%)'
        });
    }

    var ticking = false;
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                updateLogoOnScroll();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });
    
    updateLogoOnScroll();

	/*
    // ===== FLOATING CTA =====
    var sections = $('section[data-section="heroType3"]');
    
    sections.each(function() {
        var $section = $(this);
        var $ctaContainer = $section.find('.block-floating-cta');
        if (!$ctaContainer.length) return;

        var maxTranslate = 12;
        
        gsap.set($ctaContainer[0], {
            yPercent: -50
        });
        
        function moveToRandomPoint() {
            var targetX = (Math.random() - 0.5) * 2 * maxTranslate;
            var targetY = (Math.random() - 0.5) * 2 * maxTranslate;
            
            gsap.to($ctaContainer[0], {
                x: targetX,
                y: targetY,
                duration: 3,
                ease: "none",
                onComplete: moveToRandomPoint
            });
        }
        
        moveToRandomPoint();
    });
	*/
    
    // ===== ROTATING ICON (DESKTOP ONLY) =====
    var $earlsFigure = $('.big-logo svg:first-child');
    if ($earlsFigure.length > 0) {
        var currentRotation = 0;
        var rotationObj = { rotation: 0 };
        
        function scheduleNextRotation() {
            var delay = 3000 + Math.random() * 2000;
            
            setTimeout(function() {
                var rotation = 45 + Math.random() * 15;
                currentRotation += rotation;

				console.log(`Rotation value: ${currentRotation}`)
                
                gsap.to(rotationObj, {
                    rotation: currentRotation,
                    duration: 0.2,
                    ease: "linear",
                    onUpdate: function() {
                        $earlsFigure.css('transform', 'rotate(' + rotationObj.rotation + 'deg)');
                    }
                });
                
                scheduleNextRotation();
            }, delay);
        }
        
        scheduleNextRotation();
    }
});
